import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "./useIsMobile";
import { getLastEstimate, isOnLastEstimate } from "../utils/lastEstimate";

// Single source of truth for "how tall is the sticky nav chrome right now,"
// so a page's own `calc(100vh - Npx)` content area always matches what Nav.jsx
// actually renders. Desktop nav is a fixed 92px (52 header + 40 tool bar)
// plus a 28px strip that only appears when the "jump back to estimate"
// breadcrumb is showing — see Nav.jsx. Mobile has no equivalent chrome below
// its single 52px bar (the back-link lives inside the slide-down menu there).
const MOBILE_HEIGHT = 52;
const DESKTOP_BASE_HEIGHT = 92;
const DESKTOP_BACKLINK_HEIGHT = 28;

export function useNavHeight() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [showsBacklink, setShowsBacklink] = useState(false);

  useEffect(() => {
    const last = getLastEstimate();
    setShowsBacklink(!!last && !isOnLastEstimate(last, location.pathname));
  }, [location.pathname]);

  if (isMobile) return MOBILE_HEIGHT;
  return DESKTOP_BASE_HEIGHT + (showsBacklink ? DESKTOP_BACKLINK_HEIGHT : 0);
}
